import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "errors"]

  connect() {
    this.validatePassword()
  }

  validatePassword() {
    const password = this.inputTarget.value
    const errors = []

    if (password.length > 0) {
      if (password.length < 9) {
        errors.push("Must be at least 9 characters long")
      }

      if (!/[a-z]/.test(password)) {
        errors.push("Must contain at least one lowercase letter")
      }

      if (!/[A-Z]/.test(password)) {
        errors.push("Must contain at least one uppercase letter")
      }

      if (!/\d/.test(password)) {
        errors.push("Must contain at least one number")
      }

      if (!/[\W_]/.test(password)) {
        errors.push("Must contain at least one special character")
      }
    }

    this.displayErrors(errors)
    this.updateInputStyling(errors.length === 0 && password.length > 0)
  }

  displayErrors(errors) {
    if (this.hasErrorsTarget) {
      if (errors.length > 0) {
        this.errorsTarget.innerHTML = `
          <ul class="mt-2 text-sm text-red-600 dark:text-red-500 list-disc list-inside">
            ${errors.map(error => `<li>${error}</li>`).join('')}
          </ul>
        `
        this.errorsTarget.classList.remove('hidden')
      } else {
        this.errorsTarget.classList.add('hidden')
      }
    }
  }

  updateInputStyling(isValid) {
    const input = this.inputTarget
    const password = input.value

    // Remove all existing validation classes
    input.classList.remove('password-field-default', 'password-field-valid', 'password-field-invalid')

    if (password.length === 0) {
      // Default styling for empty field
      input.classList.add('password-field-default')
    } else if (isValid) {
      // Valid password styling
      input.classList.add('password-field-valid')
    } else {
      // Invalid password styling
      input.classList.add('password-field-invalid')
    }
  }
}